import { Autocomplete, Box, Button, Divider, Grid, IconButton, Modal, Stack, TextField, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next';
import { Field } from '../miProfile/Field';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useForm } from '../../../hooks';
import { useDispatch, useSelector } from 'react-redux';
import { unSelectVehicle } from '../../../store/vehicle/vehicleSlice';
import { editVehicle } from '../../helpers/vehicle';
import { DateInput } from '../DateInput';
import { toEnglishDate } from '../../../helpers/dateFormat';
import { style } from '../../../helpers/editStyle';

const optionsModality = ['Clubs', 'Fondos']
const optionsHoldings = ['Faraday Venture Partners SL', 'Faraday Venture Capital SGEIC SA de CV', 'Faraday Oportunidad I, SL', 'Faraday Oportunidad II, SL', 'Faraday Oportunidad III, SL', 'Faraday Oportunidad IV, SL' ]

export const EditVehicle = ({ setHidden, setReloadData }) => {

    const { t } = useTranslation('global');
    const { dataToAction } = useSelector(state => state.vehicle)
    const dispatch = useDispatch();
    const [formValues, handleInputChange, reset] = useForm({ ...dataToAction, created: toEnglishDate(dataToAction.created) });

    const { name, key, created, modality, holding, address, zipCode } = formValues;


    const handleCancel = () => {
        reset()
        dispatch(unSelectVehicle())
        setHidden(false)
    }
    const onSubmit = (e) => {
        e.preventDefault();
        editVehicle(formValues, t('editpartner.succesMsg'), t('editpartner.errorMsg'), t('vehiclestable.errorNameDuplicated'))
        setReloadData(prevState => !prevState)
        setHidden(false)
    }

    return (
        <>
            <Modal
                open={true}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ zIndex: 9999 }}
            >
                <Box sx={style}>
                    <Stack direction='row' justifyContent='space-between' alignItems='baseline' sx={{ height: '50px' }}>
                        <Typography color='primary' marginBottom='10px' variant='h5' fontWeight={700}>{t('vehiclestable.title')}</Typography>
                        <IconButton color='primary' onClick={handleCancel}>
                            <CloseRoundedIcon />
                        </IconButton>
                    </Stack>
                    <form onSubmit={onSubmit} style={{ padding: '10px 5px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                        <Stack sx={{ height: 'calc(70vh - 200px)', overflowY: 'auto', paddingBottom: '10px', paddingRight: '20px' }}>

                            <Grid container direction='row' width='100%' >
                                <Grid item xs={12} padding='0 5px'>
                                    <Field translation='vehiclestable' name={name} title='name' handleInputChange={handleInputChange} required={true} />
                                </Grid>
                            </Grid>

                            <Grid container direction='row' width='100%'>
                                <Grid item xs={12} padding='0 5px'>
                                    <Field translation='vehiclestable' name={key} title='key' handleInputChange={handleInputChange} />
                                </Grid>
                            </Grid>

                            <Grid container direction='row' width='100%'>
                                <Grid item xs={12} padding='0 5px'>
                                    <Field translation='vehiclestable' name={address} title='address' handleInputChange={handleInputChange} />
                                </Grid>
                            </Grid>

                            <Grid container direction='row' width='100%' >
                                <Grid item xs={12} padding='0 5px'>
                                    <Typography variant='overline' color='secondary'>{t('vehiclestable.holding')}</Typography>
                                    <Autocomplete
                                        disablePortal
                                        options={optionsHoldings}
                                        size='small'
                                        renderInput={(params) => <TextField  {...params} variant='outlined' name='holding' />}
                                        value={holding}
                                        onSelect={handleInputChange}
                                        required
                                    />
                                </Grid>
                            </Grid>

                            <Grid container direction='row' width='100%' >
                                <Grid item xs={12} md={6} padding='0 5px'>
                                    <DateInput name={created} title='created' handleInputChange={handleInputChange} required={true} />
                                </Grid>
                                <Grid item xs={12} md={6} padding='0 5px'>
                                    <Field translation='vehiclestable' name={zipCode} title='zipCode' handleInputChange={handleInputChange} />
                                </Grid>
                            </Grid>

                            <Grid container direction='row' width='100%' >
                                <Grid item xs={12} padding='0 5px'>
                                    <Typography variant='overline' color='secondary'>{t('vehiclestable.modality')}</Typography>
                                    <Autocomplete
                                        disablePortal
                                        options={optionsModality}
                                        size='small'
                                        renderInput={(params) => <TextField  {...params} variant='outlined' name='modality' />}
                                        value={modality}
                                        onSelect={handleInputChange}
                                        required
                                    />
                                </Grid>
                            </Grid>
                        </Stack>

                        <Stack sx={{ heigth: '80px' }}>
                            <Divider sx={{ margin: '30px 0px 15px 0px' }} />

                            <Grid container direction='row' width='100%' >
                                <Grid item xs={12} md={6} padding='0 5px'>
                                    <Button fullWidth onClick={handleCancel} variant="text">{t("createPassword.cancelButton")}</Button>
                                </Grid>
                                <Grid item xs={12} md={6} padding='0 5px'>
                                    <Button fullWidth type='submit' variant="contained">{t("createPassword.principalButton")}</Button>
                                </Grid>
                            </Grid>
                        </Stack>
                    </form>

                </Box>
            </Modal>
        </>
    )
}